import LinkToDocusaurus from '../LinkToDocusaurus'
import { coverageReport } from '../../docs-routes'

const LinkToCoverageReportDoc = () =>
  <LinkToDocusaurus path={coverageReport}>
    Learn more about Coverage Report
  </LinkToDocusaurus>

export default LinkToCoverageReportDoc
